// import { useTranslation } from "react-i18next";
// import Tabs from "../components/Tabs";

// function Students() {
//   const { t } = useTranslation();
//   // make sure to replace the URL with the actual one you want to use

//   return (
//     <div className="polls">
//       <div
//         style={{
//           width: "100%",
//           height: "calc(100vh - 123px)",
//           position: "relative",
//           aspectRatio: "16/9", // Maintain aspect ratio for responsiveness
//           maxWidth: "100vw",
//           maxHeight: "100vh",
//           overflow: "hidden",
//         }}
//       >
//         <iframe
//           // src="https://students.loonlog.ca"
//           // src="http://localhost:3001/categories?q=students"
//           src="https://exams.loonlog.ca/categories?q=students"
//           style={{
//             width: "100%",
//             height: "100%",
//             border: "none",
//             display: "block",
//             minHeight: 300,
//           }}
//           frameBorder="0"
//           title="Students"
//           scrolling="auto"
//           allowFullScreen
//         />
//       </div>
//     </div>
//   );
// }

// function Career() {
//   return (
//     <div
//       style={{
//         width: "100%",
//         position: "relative",
//         height: "100%",
//       }}
//     >
//       <iframe
//         // src="http://localhost:3001/categories?q=career"
//         src="https://exams.loonlog.ca/categories?q=career"
//         style={{
//           width: "100%",
//           height: "100%",
//           border: "none",
//         }}
//         title="Exams"
//       />
//     </div>
//   );
// }

// const StudyPage = () => {
//   const { t } = useTranslation();
//   return (
//     <div className="study-page">
//       <Tabs
//         tabs={[
//           { label: t("students"), path: "study", Component: Students },
//           { label: t("career"), path: "exams", Component: Career },

//           // { label: "🎓 Students", path: "study", Component: Students },
//           // { label: "💼 Career", path: "exams", Component: Career },
//         ]}
//         basePath="/study"
//       />
//     </div>
//   );
// };

// export default StudyPage;
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async"; // <-- ADD THIS
import Tabs from "../components/Tabs";

function Students() {
  const { t } = useTranslation();

  return (
    <div className="polls">
      <div
        style={{
          width: "100%",
          height: "100vh",
          // height: "calc(100vh - 123px)",
          position: "relative",
          aspectRatio: "16/9",
          maxWidth: "100vw",
          maxHeight: "100vh",
          overflow: "hidden",
        }}
      >
        <iframe
          // src="http://localhost:3001/categories?q=students"
          src="https://exams.loonlog.ca/categories?q=students"
          style={{
            width: "100%",
            height: "100%",
            border: "none",
            display: "block",
            minHeight: 300,
          }}
          frameBorder="0"
          title="Students"
          scrolling="auto"
          allowFullScreen
        />
      </div>
    </div>
  );
}

function Career() {
  return (
    <div
      style={{
        width: "100%",
        position: "relative",
        height: "100%",
      }}
    >
      <iframe
        // src="http://localhost:3001/categories?q=career"
        src="https://exams.loonlog.ca/categories?q=career"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
        title="Exams"
      />
    </div>
  );
}

const StudyPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="study-page">
        <Tabs
          tabs={[
            { label: t("students"), path: "study", Component: Students },
            { label: t("career"), path: "exams", Component: Career },
          ]}
          basePath="/study"
        />
      </div>
    </>
  );
};

export default StudyPage;
